import { IslandComponent, IslandName, IslandProps } from './types';

export type IslandHost = {
  id: number;
  name: IslandName;
  el: HTMLElement;
  Component: IslandComponent;
  props: IslandProps;
  /** Server-rendered placeholder (skeleton) to drop once the island paints. */
  placeholderNodes: ChildNode[];
};

// The island hosts found on the page. Lives outside React so `mount()` can be
// called again for markup inserted later; `IslandRoot` subscribes to it.
let hosts: IslandHost[] = [];
let nextId = 0;
const listeners = new Set<() => void>();

export const addHosts = (newHosts: Omit<IslandHost, 'id'>[]) => {
  if (!newHosts.length) {
    return;
  }

  hosts = [
    ...hosts,
    ...newHosts.map((host) => {
      nextId += 1;

      return { ...host, id: nextId };
    }),
  ];
  listeners.forEach((listener) => listener());
};

export const subscribeHosts = (listener: () => void) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

export const getHosts = () => hosts;

/** The host page has mounted this island; always false on the SPA. */
export const isIslandMounted = (name: IslandName): boolean =>
  hosts.some((host) => host.name === name);
